/**
 * 🎨 Function which maps currency to color
 * @param currency 
 * @returns 
 */
export default function mapCurrencyToColor(currency: string): string {
  switch (currency) {
    case "BTC": return "#FF9900";
    case "LTC": return "#949494";
    case "ETH": return "#497493";
    case "XMR": return "#FC6621";
    case "BNB": return "#a37d02";
    case "DOT": return "#E5918F";
    case "XBT": return "#FF9900";
    case "ETC": return "#669073";
    case "ADA": return "#000033";
    case "XRP": return "#00AAE4";
    case "SOL": return "#C13AF4";
    case "UNI": return "#FF007A";
    case "MATIC": return "#2A90FC";
    case "TRX": return "#FF0013";
    case "CAKE": return "#D1884F";
    case "LINK": return "#335DD2";
    case "DOGE": return "#BB9F33";
    case "KSM": return "#000000";
    case "ONE": return "#5BEEC2";
    case "VET": return "#1CB7FA";
    case "BCH": return "#8DC351";
    case "XLM": return "#000000";
    case "EOS": return "#000000";
    case "FTM": return "#1969ff";
    case "AVAX": return "#E84142";
    case "RUNE": return "#00F1B8";
    case "ALPHA": return "#173999";
    case "MIOTA": return "#242424";
    case "CHZ": return "#CD0124";
    case "EGLD": return "#0D022B";
    case "LUNA": return "#FFD83D";
    case "ALGO": return "#AB1C6E";
    case "SAND": return "#00AEEF";
    case "SRM": return "#47cbdd";
    case "ENJ": return "#9468ff";
    case "MANA": return "#ff4956";
    case "RAY": return "#614ffe";
    case "ALICE": return "#EA8397";
    case "SNX": return "#01D1FF";
    case "COTI": return "#2284C6";
    case "SUSHI": return "#DE60A9";
    case "1INCH": return "#1B314F";
    case "MBOX": return "#2C5EF5";
    case "NEAR": return "#4A4F55";
    case "CRV": return "#4DFFAA";
    case "QNT": return "#262261";
    case "GALA": return "#88B6C6";
    case "WAXP": return "#FEC72B";
    case "C98": return "#E5C455";
    case "AXS": return "#0249BB";
    case "FTT": return "#62D1E5";

    // Stable coins
    case "USDC": return "#2775CA";
    case "EUR": return "#9FCDCD";
    case "BUSD": return "#f3ba2f";
    case "USDT": return "#0ECC8D";
    case "USD": return "#0ECC8D"

    // Stable coins and Crypto
    case "Stablecoins": return "#0ECC8D";
    case "Crypto": return "#FF9900";

    default: return "#ECECEC";
  }
}